const publicPath = process.env.REACT_APP_PUBLIC_PATH;
export const routeCodes = {
    BASE: publicPath,
    HOME: `${publicPath}home`,
    LOGIN: `${publicPath}login`,
    MESSAGE: `${publicPath}message`,
    SETTINGS: `${publicPath}settings`,
    CAMBIOPASS: `${publicPath}passchange`,
};